import { create } from 'zustand';
import type { SubscriptionInfo } from '@/types/subscription';

interface SubscriptionState {
  subscription: SubscriptionInfo | null;
  isLoading: boolean;
  error: string | null;
  setSubscription: (sub: SubscriptionInfo | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearSubscription: () => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  subscription: null,
  isLoading: false,
  error: null,

  setSubscription: (sub) => set({ subscription: sub, error: null }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  clearSubscription: () => set({ subscription: null, error: null }),
}));
